import React, { useEffect, useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import ModalHelp from '../../../components/ModalHelp';
import { ContaServico } from '../../../viewmodel/ContaServicoViewModel';
import UsuarioViewModel from '../../../viewmodel/usuario/UsuarioViewModel';
import Usuario from '../../../model/Usuario/Usuario';

interface Props {
    show: boolean;
    conta: ContaServico | null;
    onConfirm: () => void;
    onClose: () => void;
    isLoading?: boolean;
}

const RevogacaoContaModal: React.FC<Props> = ({
    show,
    conta,
    onConfirm,
    onClose,
    isLoading = false
}) => {

    const [responsavel, setResponsavel] = useState<Usuario | null>(null);
    

    const fetchResponsavel = async (responsavelId?: string) => {
        if (!responsavelId) return;

        try {
            const usuario = await UsuarioViewModel.getUsuario(responsavelId);
            setResponsavel(usuario);
        } catch (error) {
            console.error('Erro ao buscar responsável:', error);
        }
    };

    useEffect(() => {
        fetchResponsavel(conta?.responsavelId);
    }, [conta?.responsavelId]);


    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Confirmar Revogação</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalHelp text="A revogação desativa permanentemente a conta de serviço. Todas as integrações que usam esta conta deixarão de funcionar. Esta ação não pode ser desfeita." />
                <Alert variant="danger">
                    <strong>Atenção!</strong> Esta ação é irreversível. Ao revogar a conta de serviço:
                    <ul className="mt-2">
                        <li>Todos os acessos serão imediatamente suspensos</li>
                        <li>Não será possível reativar a conta sem realizar o procedimento padrão completo</li>
                        <li>Será necessário criar uma nova conta se necessário</li>
                    </ul>
                </Alert>

                {conta && (
                    <div className="mt-3">
                        <p>Você está prestes a revogar a seguinte conta:</p>
                        <div className="bg-light p-3 rounded">
                            <p className="mb-1"><strong>Client ID:</strong> {conta.clientId}</p>
                            <p className="mb-0"><strong>Unidade:</strong> {conta.unidadeId}</p>
                            <p className="mb-0"><strong>Responsável atual:</strong> {responsavel ? responsavel.nome : 'erro ao carregar'}</p>
                        </div>
                    </div>
                )}

                <p className="mt-3 fw-bold">Deseja realmente prosseguir com a revogação?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={isLoading}>
                    Cancelar
                </Button>
                <Button
                    variant="danger"
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    {isLoading ? 'Revogando...' : 'Confirmar Revogação'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RevogacaoContaModal;